<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.41067 13.0158L13.0157 4.41083C13.3407 4.08583 13.8682 4.08583 14.1932 4.41083L15.5898 5.8075C15.9148 6.1325 15.9148 6.66 15.5898 6.985L6.984 15.5892C6.82817 15.7458 6.6165 15.8333 6.39567 15.8333H4.1665V13.6042C4.1665 13.3833 4.254 13.1717 4.41067 13.0158Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4585 5.96667L14.0335 8.54167"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
